// Version check utility - checks for new deployments
const VERSION_CHECK_INTERVAL = 60000; // Check every 60 seconds

let currentBuildId = null;

export const initVersionCheck = () => {
  // Get initial build ID from meta tag or generate from load time
  currentBuildId = document.querySelector('meta[name="build-id"]')?.content || Date.now().toString();
  
  // Start periodic check
  setInterval(checkForUpdates, VERSION_CHECK_INTERVAL);
};

const checkForUpdates = async () => {
  try {
    // Fetch index.html with cache-busting
    const response = await fetch(`/?_=${Date.now()}`, {
      method: 'HEAD',
      cache: 'no-store'
    });
    
    // Check ETag or Last-Modified header for changes
    const etag = response.headers.get('etag');
    const lastModified = response.headers.get('last-modified');
    const newBuildId = etag || lastModified || '';
    
    if (currentBuildId && newBuildId && currentBuildId !== newBuildId) {
      console.log('[Version Check] New version detected, reloading...');
      // Reload without cache
      window.location.reload();
    }
  } catch (error) {
    // Silently fail - don't interrupt user experience
    console.debug('[Version Check] Check failed:', error);
  }
};

export default initVersionCheck;
